import { useEffect } from 'react';
import { Box, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
// Components
import { Page, Breadcrumb } from '@/components/common/index';
import { ViewOptions } from './components';
import { PaymentType } from '../checkout/components/Fund/fundComponents';
// Hooks
import { useStoreContext } from '@/providers/StoreProvider';
import { useCurrency } from '@/providers/CurrencyProvider';
import { useIsMobile } from '@/hooks/useIsMobile';

export function StoreLayout({ children, showBreadCrumb = false }) {
  const isMobile = useIsMobile(520);
  const { currencyKey, handleSetCurrency, allCurrencies } = useCurrency();
  const { handleSetSearchState, storeItems, resetSearch, search, setView, view } =
    useStoreContext();

  const handleSetView = (viewOption) => {
    setView(viewOption);
  };

  const handleSearch = () => {
    const searchText = search.toLowerCase();
    const items = storeItems.filter(({ name }) =>
      name.toLowerCase().includes(`${searchText}`)
    );
    handleSetSearchState({ filteredProducts: items, searchError: items.length === 0 });
  };

  const handleSearchChange = (e) => handleSetSearchState({ search: e.target.value });

  useEffect(() => {
    if (search.length >= 2) {
      handleSearch();
    } else if (!search.length) {
      resetSearch();
    }
  }, [search]);

  return (
    <Page>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          marginBottom: '24px',
        }}
      >
        <Box>
          <Typography variant="h2">Explore Products</Typography>
        </Box>
        {showBreadCrumb ? (
          <Breadcrumb />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '24px',
            }}
          >
            <TextField
              size="small"
              type="text"
              placeholder="Search"
              onChange={handleSearchChange}
              value={search}
              data-core-qa="storeInputSearch"
              id="storeInputSearch"
              InputProps={{
                startAdornment: <Search fontSize="small" sx={{ marginRight: '8px' }} />,
                endAdornment: (
                  <>
                    {search ? (
                      <Close
                        fontSize="small"
                        onClick={resetSearch}
                        sx={{ cursor: 'pointer' }}
                      />
                    ) : null}
                  </>
                ),
              }}
              fullWidth
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: isMobile ? 'space-between' : 'flex-end',
                gap: '24px',
                width: '100%',
              }}
            >
              {allCurrencies.length ? (
                <PaymentType
                  isStore
                  currency={currencyKey}
                  setCurrency={handleSetCurrency}
                  defaultCurrency={currencyKey}
                  currencies={allCurrencies}
                />
              ) : (
                <CircularProgress />
              )}
              <ViewOptions
                selectedOption={view}
                handleSetView={handleSetView}
                data-core-qa="storeViewOptions"
              />
            </Box>
          </Box>
        )}
      </Paper>
      {children}
    </Page>
  );
}
